import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostListener, Inject, inject, PLATFORM_ID, Renderer2, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProductImageZoomViewComponent } from '@spartacus/product/image-zoom/components';
import { ICON_TYPE, FocusConfig, CurrentProductService, LaunchDialogService, BreakpointService } from '@spartacus/storefront';
import { PanZoomConfig, PanZoomAPI, Rect } from 'ngx-panzoom';
import { Subscription } from 'rxjs';

const VIEW360_NAVIGATION = 'View360-navigationFullscreenEnter';
const VIEW360_NAVIGATION_FULL = 'View360-navigationFullscreenExit';
const CUSTOM_ZOOM = '.custom-imgaeZoom';
declare const View360: any;
declare global {
  interface Window {
    MSStream?: any;
  }
}
@Component({
  selector: 'app-kb-custom-image-zoom',
  templateUrl: './kb-custom-image-zoom.component.html',
  styleUrl: './kb-custom-image-zoom.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class KbCustomImageZoomComponent {

  /*   imageUrl: string;
    panZoomConfig: PanZoomConfig = new PanZoomConfig();
    platformId = inject(PLATFORM_ID);
    isIos = isPlatformBrowser(this.platformId) ? /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream : '';
    private panZoomAPI: PanZoomAPI;
  
    private apiSubscription = new Subscription();
    @ViewChild('panzoom-element') panzoomElement: ElementRef;
    constructor(
      public dialogRef: MatDialogRef<KbCustomImageZoomComponent>,
      private renderer: Renderer2, private el: ElementRef,
      @Inject(MAT_DIALOG_DATA) public data: any
  
    ) {
      this.imageUrl = data?.imageUrl;
      this.panZoomConfig = new PanZoomConfig({
        zoomLevels: 10,
        scalePerZoomLevel: 1.5,
        friction: 10,
        haltSpeed: 100,
        initialPanX: 0,
        initialPanY: 0,
        keepInBounds: true,
        keepInBoundsDragPullback: 0.7,
        keepInBoundsRestoreForce: 0.5,
        panOnClickDrag: true,
        dragMouseButton: 'left',
        zoomButtonIncrement: 1,
        zoomOnDoubleClick: false,
        zoomOnMouseWheel: false,
        invertMouseWheel: false,
        zoomStepDuration: 0.2,
        zoomToFitZoomLevelFactor: 0.95,
        freeMouseWheel: true,
        freeMouseWheelFactor: 0.1,
        noDragFromElementClass: 'no-drag',
        acceleratePan: true,
        dynamicContentDimensions: true,
      });
  
  
    }
  
    @HostListener('document:keydown.escape', ['$event'])
    handleEscape(event: KeyboardEvent) {
      this.toggleFullScreen();
    }
    ngOnInit() {
      if (isPlatformBrowser(this.platformId)) {
        document.addEventListener('fullscreenchange', this.onFullscreenChange.bind(this));
        const view = new View360();
        this.apiSubscription.add(this.panZoomConfig.api.subscribe(
          (api: PanZoomAPI) => {
            this.panZoomAPI = api;
  
          }
        ));
      }
  
    }
  
  
  
  
    zoomIn() {
      this.panZoomAPI.zoomIn();
    }
    fitToScreen() {
      this.panZoomAPI.centerContent();
    }
  
    zoomOut() {
      this.panZoomAPI.zoomOut();
    }
  
  
    toggleFullScreen() {
      if (this.isIos) {
        this.togglePseudoFullscreen();
        return;
      }
      if (isPlatformBrowser(this.platformId)) {
        const elem = document.documentElement;
        const button = document.querySelector('.tgleBtn');
        const customImageZoom = document.querySelector(CUSTOM_ZOOM);
  
        if (!document.fullscreenElement) {
          elem.requestFullscreen()
            .then(() => {
              setTimeout(() => {
                const view360Elements = document.querySelectorAll('.View360-holderFullscreen') as NodeListOf<HTMLElement>;
                view360Elements.forEach(el => el.remove());
  
                if (customImageZoom && button) {
                  customImageZoom.classList.add('ImageFullScreen');
                  button.classList.remove(VIEW360_NAVIGATION);
                  button.classList.add(VIEW360_NAVIGATION_FULL);
                }
              }, 200);
            })
            .catch(err => {
              console.error('Failed to enter fullscreen:', err);
            });
        } else {
          document.exitFullscreen()
            .then(() => {
              if (customImageZoom && button) {
                customImageZoom.classList.remove('ImageFullScreen');
                button.classList.remove(VIEW360_NAVIGATION_FULL);
                button.classList.add(VIEW360_NAVIGATION);
              }
            })
            .catch(err => {
              console.error('Failed to exit fullscreen:', err);
            });
        }
      }
    }
  
    togglePseudoFullscreen() {
      if (isPlatformBrowser(this.platformId)) {
        const customImageZoom = document.querySelector(CUSTOM_ZOOM);
        const button = document.querySelector('.tgleBtn');
  
        if (!customImageZoom || !button) {
          return;
        }
  
        if (customImageZoom.classList.contains('ImageFullScreen')) {
          customImageZoom.classList.remove('ImageFullScreen');
          button.classList.remove(VIEW360_NAVIGATION_FULL);
          button.classList.add(VIEW360_NAVIGATION);
        } else {
          customImageZoom.classList.add('ImageFullScreen');
          button.classList.remove(VIEW360_NAVIGATION);
          button.classList.add(VIEW360_NAVIGATION_FULL);
        }
      }
    }
  
    onFullscreenChange() {
      if (isPlatformBrowser(this.platformId)) {
        const button = document.querySelector('.tgleBtn');
        const customImageZoom = document.querySelector(CUSTOM_ZOOM);
  
        if (document.fullscreenElement) {
          button?.classList.remove(VIEW360_NAVIGATION);
          button?.classList.add(VIEW360_NAVIGATION_FULL);
          customImageZoom?.classList.add('ImageFullScreen');
        } else {
          button?.classList.remove(VIEW360_NAVIGATION_FULL);
          button?.classList.add(VIEW360_NAVIGATION);
          customImageZoom?.classList.remove('ImageFullScreen');
        }
        this.panZoomAPI.resetView();
      }
    }
    reset() {
      this.panZoomAPI.resetView();
    }
    ngOnDestroy(): void {
      if (isPlatformBrowser(this.platformId)) {
        document.removeEventListener('fullscreenchange', this.onFullscreenChange.bind(this));
      }
      this.apiSubscription.unsubscribe();
    } */
  imageUrl!: string;
  panZoomConfig: PanZoomConfig = new PanZoomConfig();
  iconType = ICON_TYPE;
  private panZoomAPI!: PanZoomAPI;
  private timeout?: ReturnType<typeof setTimeout> | null = null;
  private apiSubscription = new Subscription();
  private enteredFullscreen = false;

  // ✅ boolean (not string)
  isIos: boolean = false;

  @ViewChild('dialogRoot', { static: true }) dialogRootRef!: ElementRef<HTMLElement>;
  @ViewChild('panzoomElement', { static: true }) panzoomElement!: ElementRef<HTMLDivElement>;

  constructor(
    public dialogRef: MatDialogRef<KbCustomImageZoomComponent>,
    private el: ElementRef,
    @Inject(MAT_DIALOG_DATA) public data: any,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.imageUrl = data?.imageUrl;

    this.panZoomConfig = new PanZoomConfig({
      zoomLevels: 10,
      scalePerZoomLevel: 1.5,
      friction: 10,
      haltSpeed: 100,
      initialPanX: 0,
      initialPanY: 0,
      keepInBounds: true,
      keepInBoundsDragPullback: 0.7,
      keepInBoundsRestoreForce: 0.5,
      panOnClickDrag: true,
      dragMouseButton: 'left',
      zoomButtonIncrement: 1,
      zoomOnDoubleClick: false,
      zoomOnMouseWheel: false,
      invertMouseWheel: false,
      zoomStepDuration: 0.2,
      zoomToFitZoomLevelFactor: 0.95,
      freeMouseWheel: true,
      freeMouseWheelFactor: 0.1,
      noDragFromElementClass: 'no-drag',
      acceleratePan: true,
      dynamicContentDimensions: true,
    });
  }

  /** ===== Helpers ===== */
  private getFullscreenElement(): Element | null {
    const doc: any = document;
    return doc.fullscreenElement || doc.webkitFullscreenElement || doc.msFullscreenElement || null;
  }

  /** Pseudo FS: apply class on the dialog container (matches your 360 flow) */
  public applyPseudoFullscreenFromLauncher(): void {
    const customImageZoom = document.querySelector(CUSTOM_ZOOM);
    const button = document.querySelector('.tgleBtn');

    document.body.classList.add('no-scroll');
    customImageZoom?.classList.add('ImageFullScreen');
    button?.classList.remove(VIEW360_NAVIGATION);
    button?.classList.add(VIEW360_NAVIGATION_FULL);

    this.enteredFullscreen = true;
    this.afterEnterFullscreen();
  }

  private afterEnterFullscreen(): void {
    try {
      this.panZoomAPI?.resetView();
      this.panZoomAPI?.centerContent();
    } catch { }
  }

  /** ===== Lifecycle ===== */
  ngOnInit(): void {

    if (isPlatformBrowser(this.platformId)) {
      document.addEventListener('fullscreenchange', this.onFullscreenChange.bind(this));
      const view = new View360();
      // Proper boolean iOS flag
      this.isIos = /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;

      // Sync classes and close on native FS exit
      document.addEventListener('fullscreenchange', this.onFullscreenChange);
      document.addEventListener('webkitfullscreenchange', this.onFullscreenChange as any);
      document.addEventListener('msfullscreenchange', this.onFullscreenChange as any);
      this.apiSubscription = this.panZoomConfig.api.subscribe(
        (api: PanZoomAPI) => {
          this.panZoomAPI = api;

        }
      );
    }

  }

  ngAfterViewInit(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    // Prevent background scroll while dialog is open
    document.body.classList.add('no-scroll');

    // ⛔ Do NOT request FS here; caller already tried inside click.
    // If native FS was denied, we'll use pseudo-FS via applyPseudoFullscreenFromLauncher().

    // Focus root so Esc works
    setTimeout(() => this.dialogRootRef?.nativeElement?.focus(), 0);
  }

  ngOnDestroy(): void {
    if (isPlatformBrowser(this.platformId)) {
      document.removeEventListener('fullscreenchange', this.onFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', this.onFullscreenChange as any);
      document.removeEventListener('msfullscreenchange', this.onFullscreenChange as any);
    }
    this.apiSubscription.unsubscribe();

    if (this.timeout) clearTimeout(this.timeout);

    // Cleanup pseudo-FS and unlock scroll
    this.cleanupFullscreenClasses();
    document.body.classList.remove('no-scroll');
  }

  /** ===== Controls ===== */
  zoomIn(): void { this.panZoomAPI?.zoomIn(); }
  zoomOut(): void { this.panZoomAPI?.zoomOut(); }
  fitToScreen(): void { this.panZoomAPI?.centerContent(); }
  reset(): void { this.panZoomAPI?.resetView(); }

  /** ===== Close / Esc ===== */
  onCloseClick(evt?: Event): void {
    evt?.stopPropagation();

    const customImageZoom = document.querySelector(CUSTOM_ZOOM);
    const button = document.querySelector('.tgleBtn');

    if (this.getFullscreenElement()) {
      const doc: any = document;
      const exit = doc.exitFullscreen || doc.webkitExitFullscreen || doc.msExitFullscreen;
      Promise.resolve(exit?.call(doc)).finally(() => {
        this.cleanupFullscreenClasses();
        this.dialogRef.close();
      });
    } else {
      this.cleanupFullscreenClasses();
      this.dialogRef.close();
    }
  }


  @HostListener('document:keydown.escape', ['$event'])
  handleEscape(event: Event): void {
    if (event instanceof KeyboardEvent) {
      this.onCloseClick();
    }
  }


  private onFullscreenChange = (): void => {
    const button = document.querySelector('.tgleBtn');
    const customImageZoom = document.querySelector(CUSTOM_ZOOM);

    if (this.getFullscreenElement()) {
      button?.classList.remove(VIEW360_NAVIGATION);
      button?.classList.add(VIEW360_NAVIGATION_FULL);
      customImageZoom?.classList.add('ImageFullScreen');
      this.enteredFullscreen = true;
      this.afterEnterFullscreen();
    } else {
      button?.classList.remove(VIEW360_NAVIGATION_FULL);
      button?.classList.add(VIEW360_NAVIGATION);
      customImageZoom?.classList.remove('ImageFullScreen');

      this.enteredFullscreen = false;
      // Close the dialog when leaving native FS
      this.dialogRef.close();
    }
  };

  private cleanupFullscreenClasses() {
    const button = document.querySelector('.tgleBtn');
    const customImageZoom = document.querySelector(CUSTOM_ZOOM);

    customImageZoom?.classList.remove('ImageFullScreen');
    button?.classList.remove(VIEW360_NAVIGATION_FULL);
    button?.classList.add(VIEW360_NAVIGATION);
  }

  /** (Optional) Keep your toggle button behavior */
  toggleFullScreen(): void {
    // On mobile/iOS, rely on pseudo-FS. On desktop, caller already requested native FS on container.
    if (this.isIos) {
      this.applyPseudoFullscreenFromLauncher();
      return;
    }
    // If user taps the button and native FS hasn't been granted,
    // fallback straight to pseudo-FS to avoid "permissions failed".
    if (!this.getFullscreenElement()) {
      this.applyPseudoFullscreenFromLauncher();
    } else {
      // Exit native FS
      const doc: any = document;
      const exit = doc.exitFullscreen || doc.webkitExitFullscreen || doc.msExitFullscreen;
      Promise.resolve(exit?.call(doc)).catch(() => { });
    }
  }


}